// import React from "react";
// import ReactDOM from "react-dom/client";
// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// import "./index.css";
// import "./theme/theme.css"; 
// import { initThemeEngine } from "./theme/themeEngine"; 

// // MUST be a capital "A" to match App.js perfectly
// import App from "./App";

// // Initialize the Theme Engine BEFORE React renders
// initThemeEngine();

// const queryClient = new QueryClient({
//   defaultOptions: {
//     queries: {
//       staleTime: 60_000,
//       refetchOnWindowFocus: false,
//     },
//   },
// });

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <QueryClientProvider client={queryClient}>
//       <App />
//     </QueryClientProvider>
//   </React.StrictMode>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";

import "./index.css";
import "./theme/theme.css";

import { initThemeEngine } from "./theme/themeEngine";
import App from "./App";

// Initialize theme engine before rendering
initThemeEngine();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);
document.addEventListener("contextmenu", (e) => {
  e.preventDefault();
});
document.addEventListener("keydown", (e) => {
  if (
    e.key === "F12" ||
    (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) ||
    (e.ctrlKey && e.key.toUpperCase() === "U")
  ) {
    e.preventDefault();
  }
});